import Home from 'containers/Home';
import Login from 'containers/Login';
import ForgotPassword from 'containers/ForgotPassword';
import ResetPassword from 'containers/ResetPassword';
import Administration from 'containers/Administration';
import Account from 'containers/Account';
import Reports from 'containers/Reports';
import RegisterUser from 'containers/Register';
import Files from 'containers/Files/Files';
import Guides from 'containers/Files/Guides';
import DataSources from 'containers/DataSources/DataSources';
import DataSource from 'containers/DataSources/DataSource';
import DemoLogin from 'containers/DemoLogin';
import UserProfile from 'containers/User/UserProfile';
import Tools from 'containers/Tools/Tools';
import RedirectToSurvey from 'containers/Surveys/RedirectToSurvey';
import DashboardSection from 'components/Dashboard/DashboardSection';

const routes = [
  {
    path: '/',
    exact: true,
    component: Home,
    public: false,
  },
  {
    path: '/login',
    exact: true,
    component: Login,
    public: true,
  },
  {
    path: '/demo',
    exact: true,
    component: DemoLogin,
    public: true,
  },
  {
    path: '/forgot-password',
    exact: true,
    component: ForgotPassword,
    public: true,
  },
  {
    path: '/reset-password/:userId/:token',
    exact: true,
    component: ResetPassword,
    public: true,
  },
  {
    path: '/register/:userId',
    exact: true,
    public: true,
    component: RegisterUser,
  },
  {
    path: '/reports',
    exact: false,
    component: Reports,
    public: false,
  },
  {
    path: '/administration',
    exact: false,
    component: Administration,
    public: false,
  },
  {
    path: '/account',
    exact: false,
    component: Account,
    public: false,
  },
  {
    path: '/data-sources/:dataSourceId',
    exact: false,
    component: DataSource,
    public: false,
  },
  {
    path: '/data-sources',
    exact: true,
    component: DataSources,
    public: false,
  },
  {
    path: '/files',
    exact: false,
    component: Files,
    public: false,
  },
  {
    path: '/guides',
    exact: false,
    component: Guides,
    public: false,
  },
  {
    path: '/user',
    exact: true,
    component: UserProfile,
    public: false,
  },
  {
    path: '/tools',
    exact: false,
    component: Tools,
    public: false,
  },
  {
    path: '/surveys/:surveyId',
    exact: true,
    component: RedirectToSurvey,
    public: false,
  },
  {
    path: '/dashboards',
    exact: false,
    component: DashboardSection,
    public: false,
  },
];

export default routes;
